.ux-iws-service-reports {
    &__list {
        list-style: none;
        padding: 0;
        margin: 0;
    }
}
